import { CircleArrowsDiff, Person, phxWebStyleTokens } from 'phx-core';

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { DUTY_STATUS_ABBR } from '../lib/duty-status-abbr';
import { GREEN_60, BLACK_60 } from '@lib/colors';

interface IDutyStatusIconConfig {
  text: string,
  contrast: string,
  intent: string,
}

interface IDutyStatusConfig {
  on_duty: IDutyStatusIconConfig,
  off_duty: IDutyStatusIconConfig,
  sleeper: IDutyStatusIconConfig,
  waiting: IDutyStatusIconConfig,
  driving: IDutyStatusIconConfig,
}

const DUTY_STATUS_CONFIG: IDutyStatusConfig = {
  on_duty: {
    text: 'ON',
    contrast: 'high',
    intent: 'accent',
  },
  off_duty: {
    text: 'OFF',
    contrast: 'transparent',
    intent: 'neutral',
  },
  sleeper: {
    text: 'SB',
    contrast: 'transparent',
    intent: 'neutral',
  },
  waiting: {
    text: 'W',
    contrast: 'transparent',
    intent: 'neutral',
  },
  driving: {
    text: 'D',
    contrast: 'high',
    intent: 'positive',
  },
};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'duty-status-icon',
  styleUrls: ['./duty-status-icon.component.scss'],
  templateUrl: './duty-status-icon.component.html',
})
export class DutyStatusIconComponent {
  @Input() public dutyStatus;
  @Input() public showLabel;
  @Input() public isEldGenerated;
  @Input() public isUpdatedByDriver;
  @Input() public showOldIcon: boolean = true;
  public circleArrowsDiff: string = CircleArrowsDiff;
  public dutyStatusConfig: IDutyStatusConfig = DUTY_STATUS_CONFIG;
  public person: string = Person;
  public readonly phxWebStyleTokens: typeof phxWebStyleTokens = phxWebStyleTokens;

  public get abbr() {
    return DUTY_STATUS_ABBR[this.dutyStatus];
  }

  public get label() {
    let dutyStatus = this.dutyStatus;

    // this is common for both EldGenerated and
    // non ELD generated
    if (dutyStatus === 'driving') {
      return $localize`driving`;
    }

    if (this.isEldGenerated) {
      if (dutyStatus === 'off_duty') {
        dutyStatus = $localize`pers conv`;
      } else if (dutyStatus === 'on_duty') {
        dutyStatus = $localize`yard move`;
      }
    } else {
      if (dutyStatus === 'on_duty') {
        dutyStatus = $localize`on duty`;
      } else if (dutyStatus === 'sleeper') {
        dutyStatus = $localize`sleeper`;
      } else if (dutyStatus === 'off_duty') {
        dutyStatus = $localize`off duty`;
      } else if (dutyStatus === 'waiting') {
        dutyStatus = $localize`waiting`;
      }
    }

    return dutyStatus;
  }
}
